<main class="main">
  <mat-dialog-content>
    <p>{{ 'maxVehiclesNotSelected' | i18next }}</p>
  </mat-dialog-content>
  <mat-dialog-actions class="main--btnContainer">
    <button
      type="button"
      class="main--btnContainer__btn btnCancel"
      (click)="btnCancel()"
    >
      {{ 'btnCancel' | i18next | uppercase }}
    </button>
    <button
      type="button"
      class="main--btnContainer__btn btnConfirm btn confirm"
      (click)="btnContinue()"
    >
      {{ 'btnContinue' | i18next | uppercase }}
    </button>
  </mat-dialog-actions>
</main>
